import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export const ProtectedRoute = ({ children }: { children: any }) => {
  const { token } = useAuth();
  const location = useLocation();

  if (!token)
    return <Navigate to={"/login"} state={{ path: location.pathname }} />;

  return children;
};
